import { resolveHttpErrorMessageKey } from '../../core/http/http-error-message.util';

export abstract class AsyncFormStateBase
{
  protected isSaving = false;
  protected errorText: string | null = null;
  protected successText: string | null = null;

  protected clearFeedback(): void
  {
    this.errorText = null;
    this.successText = null;
  }

  protected beginSaving(): void
  {
    this.isSaving = true;
    this.clearFeedback();
  }

  protected finishSaving(): void
  {
    this.isSaving = false;
  }

  protected setSuccess(message: string): void
  {
    this.successText = message;
    this.errorText = null;
  }

  protected setError(message: string): void
  {
    this.errorText = message;
    this.successText = null;
  }

  protected setHttpError(error: unknown, fallback = 'error.generic'): void
  {
    this.setError(resolveHttpErrorMessageKey(error, { fallback }));
  }
}
